import NamedDto from 'modules/base/dto/NamedDto';
import nBossConnection from 'modules/base/service/nBossConnection';

class PiConnectionService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'piConnectionControl';
	}

	/** @return {Promise<NamedDto[]>} */
	getListSelection() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/getListSelection`)
				.then(response => resolve(response.data != null ? response.data.map(item => new NamedDto().setup(item)) : []))
				.catch(reject);
		});
	}
}

export default new PiConnectionService();
